import React, { createContext, useContext, useMemo, useState } from "react";

const translations = {
  pt: {
    nav: {
      method: "STRATFLOW®",
      services: "O que fazemos",
      cases: "Resultados",
      clients: "Experiências",
      contact: "Conversar",
      cta: "Falar com a gente",
    },
    hero: {
      eyebrow: "GT Strategy, desde 2017",
      title_a: "Estratégia",
      title_b: "em execução.",
      title_c: "Sem rodeios.",
      subtitle:
        "Vamos direto ao ponto: qual o desafio que você precisa resolver agora?",
      cta_primary: "Iniciar uma conversa",
      cta_secondary: "Ver o que fazemos",
      meta_a: "+45 projetos",
      meta_b: "Setores: indústria, infra, serviços, energia, cripto",
      meta_c: "Resultados em até 90 dias",
    },
    pillars: {
      eyebrow: "Como pensamos",
      title_a: "Adaptamos a solução",
      title_em: "ao seu contexto.",
      subtitle:
        "Cada empresa é única. Em vez de receitas prontas, combinamos estratégia, processo, dados e cultura no formato que faz sentido para a sua realidade.",
      items: [
        { t: "Direto ao ponto.", d: "Diagnóstico objetivo, plano claro e execução com cadência. Sem entregáveis que ficam parados na gaveta." },
        { t: "Continuidade do começo ao fim.", d: "A solução nasce ainda na proposta, e o time que apresenta a ideia é o mesmo que implanta. Conhecimento, vínculo e responsabilidade preservados em todo o projeto." },
        { t: "Resultado mensurável.", d: "Definimos as métricas logo no início. Você acompanha a evolução, valida e cobra em tempo real." },
        { t: "Cultura que sustenta.", d: "Implantamos rituais e governança para que a mudança permaneça depois que entregamos o projeto." },
      ],
    },
    services: {
      eyebrow: "O que fazemos",
      title_a: "Da estratégia",
      title_em: "à cultura.",
      subtitle:
        "As frentes em que mais geramos valor para os nossos clientes. Em geral, combinamos duas ou três delas para resolver o desafio de forma integrada.",
      cards: [
        { t: "Estratégia & Planejamento", d: "Direcionadores claros, metas, desdobramento e governança." },
        { t: "Excelência Operacional", d: "Redesenho de processos, PMO, VMO e ganho de eficiência." },
        { t: "Digitalização & Dados", d: "De cultura de dados a painéis e decisão por evidência." },
        { t: "Transformação Cultural", d: "Rituais, liderança, accountability e mudança que fica." },
        { t: "Portfólio & Inovação", d: "Priorização, conexão com estratégia e medição de valor." },
        { t: "Diagnóstico de Maturidade", d: "Leitura rápida do estágio atual e do caminho até onde você quer chegar." },
      ],
      cta: "Não viu o seu desafio aqui? Vamos conversar sobre ele.",
    },
    method: {
      eyebrow: "Metodologia STRATFLOW®",
      title_a: "Três movimentos.",
      title_em: "Uma jornada.",
      subtitle:
        "STRATFLOW® é a forma como conectamos estratégia, operações, tecnologia e pessoas em um único fluxo de valor.",
      steps: [
        { n: "01", title: "Clarificar o valor.", desc: "Qual valor a organização precisa gerar? Como isso vira meta, indicador e iniciativa?" },
        { n: "02", title: "Organizar o fluxo.", desc: "Redesenhamos processo, governança e portfólio para o valor fluir com cadência." },
        { n: "03", title: "Ancorar na cultura.", desc: "Rituais, acordos e accountability. A transformação deixa de ser projeto." },
      ],
    },
    cases: {
      eyebrow: "Resultados na prática",
      title_a: "Números reais.",
      title_em: "Setores diferentes.",
      subtitle: "Uma amostra do que entregamos. Números preservados, contexto real.",
      items: [
        { metric: "+42%", label: "Indústria · Eficiência operacional", desc: "Ganho em planta de reciclagem após redesenho de processos e SMO." },
        { metric: "+132%", label: "Indústria · Crescimento em 3 anos", desc: "Receita escalada por planejamento vivo e cadência de execução." },
        { metric: "94%", label: "Construção · Digitalização", desc: "Operação quase 100% digital em 3 anos - 26 POCs, 7 projetos estruturantes." },
        { metric: "+38%", label: "Infraestrutura · Mobilização", desc: "Eficiência no fluxo após transformar PMO em VMO." },
        { metric: "12→3", label: "Eletromecânica · Documentação (dias)", desc: "Tempo de documentação reduzido com 100% de aderência ao novo padrão." },
        { metric: "93%", label: "Estratégia · Aderência ao plano", desc: "SMO e governança aumentando a execução do estratégico." },
      ],
    },
    clients: {
      eyebrow: "Ambientes em que atuamos",
      title_a: "Empresas com quem",
      title_em: "aprendemos e ajudamos a evoluir.",
      subtitle:
        "Mais de uma década de experiência acumulada entre a trajetória pessoal do nosso time e os projetos da GT Strategy. Indústria, infraestrutura, energia, serviços, agro e cripto.",
    },
    contact: {
      eyebrow: "Vamos conversar",
      title_a: "Qual desafio você",
      title_em: "quer endereçar?",
      subtitle:
        "Envie uma mensagem objetiva. Respondemos com agilidade, direto pelo nosso time, sem intermediários.",
      labels: {
        name: "Nome",
        email: "E-mail",
        company: "Empresa",
        role: "Cargo",
        message: "Sobre o que você quer falar?",
      },
      placeholders: {
        name: "Seu nome",
        email: "voce@empresa.com",
        company: "Empresa",
        role: "Ex.: COO, Head de Transformação",
        message: "Em poucas linhas, descreva o contexto e o desafio em pauta.",
      },
      submit: "Enviar",
      submitting: "Enviando...",
      success: "Recebido. Em breve entraremos em contato.",
      error: "Não foi possível enviar agora. Tente novamente ou escreva direto para o Guilherme.",
      direct_email: "Ou escreva diretamente para o Guilherme:",
      side_eyebrow: "O ponto de partida",
      side_title: "Uma conversa inicial de 30 minutos.",
      side_desc:
        "Começamos entendendo o seu contexto. Quando faz sentido, evoluímos para um diagnóstico (1 a 2 semanas) com leitura clara dos próximos passos.",
      side_list: [
        "Entendimento do contexto e do que está em jogo.",
        "Mapeamento do que é endereçável em 30, 60 ou 90 dias.",
        "Proposta sob medida ou indicação honesta de parceiro.",
      ],
    },
    footer: {
      tagline: "Evoluímos negócios, transformamos culturas.",
      rights: "Todos os direitos reservados.",
      since: "GT Strategy · desde 2017",
      sections: { explore: "Navegar", contact: "Falar com a gente" },
      back_to_top: "Voltar ao topo",
      desc: "Consultoria de estratégia, excelência operacional, digitalização e cultura.",
    },
  },
  en: {
    nav: {
      method: "STRATFLOW®",
      services: "What we do",
      cases: "Results",
      clients: "Experiences",
      contact: "Talk to us",
      cta: "Get in touch",
    },
    hero: {
      eyebrow: "GT Strategy, since 2017",
      title_a: "Strategy",
      title_b: "in execution.",
      title_c: "No fluff.",
      subtitle:
        "Let's get straight to the point: what's the challenge you need to solve right now?",
      cta_primary: "Start a conversation",
      cta_secondary: "See what we do",
      meta_a: "45+ projects",
      meta_b: "Industries: manufacturing, infra, services, energy, crypto",
      meta_c: "Results in up to 90 days",
    },
    pillars: {
      eyebrow: "How we think",
      title_a: "We adapt the solution",
      title_em: "to your context.",
      subtitle:
        "Every company is unique. Instead of off-the-shelf playbooks, we combine strategy, process, data and culture in the format that fits your reality.",
      items: [
        { t: "Straight to the point.", d: "Objective diagnostic, clear plan, execution with cadence. No deliverables sitting in a drawer." },
        { t: "Continuity from start to finish.", d: "The solution is born during the proposal, and the team that presents the idea is the team that implements it. Knowledge, relationship and accountability preserved throughout." },
        { t: "Measurable results.", d: "We define metrics from day one. You track progress, validate and challenge in real time." },
        { t: "Culture that sustains.", d: "We install rituals and governance so change remains long after we deliver the project." },
      ],
    },
    services: {
      eyebrow: "What we do",
      title_a: "From strategy",
      title_em: "to culture.",
      subtitle:
        "The fronts where we generate the most value for our clients. We usually combine two or three of them to address the challenge in an integrated way.",
      cards: [
        { t: "Strategy & Planning", d: "Clear value drivers, goals, deployment and governance." },
        { t: "Operational Excellence", d: "Process redesign, PMO, VMO and efficiency gains." },
        { t: "Digital & Data", d: "From data culture to dashboards and evidence-based decisions." },
        { t: "Cultural Transformation", d: "Rituals, leadership, accountability and lasting change." },
        { t: "Portfolio & Innovation", d: "Prioritization, link to strategy and value measurement." },
        { t: "Maturity Diagnostic", d: "Fast read of your current state and the path to where you want to go." },
      ],
      cta: "Don't see your challenge here? Let's discuss it.",
    },
    method: {
      eyebrow: "STRATFLOW® methodology",
      title_a: "Three moves.",
      title_em: "One journey.",
      subtitle:
        "STRATFLOW® is how we connect strategy, operations, technology and people into a single value flow.",
      steps: [
        { n: "01", title: "Clarify the value.", desc: "What value should the organization create? How does it translate into goals, indicators and initiatives?" },
        { n: "02", title: "Organize the flow.", desc: "We redesign process, governance and portfolio so value flows with cadence." },
        { n: "03", title: "Anchor in culture.", desc: "Rituals, agreements and accountability. Transformation stops being a project." },
      ],
    },
    cases: {
      eyebrow: "Results in practice",
      title_a: "Real numbers.",
      title_em: "Different sectors.",
      subtitle: "A sample of what we deliver. Figures preserved, context is real.",
      items: [
        { metric: "+42%", label: "Industry · Operational efficiency", desc: "Recycling plant after process redesign and SMO." },
        { metric: "+132%", label: "Industry · Growth in 3 years", desc: "Revenue scaled with living plan and execution cadence." },
        { metric: "94%", label: "Construction · Digitalization", desc: "Operations almost 100% digital in 3 years - 26 POCs, 7 structural projects." },
        { metric: "+38%", label: "Infrastructure · Mobilization", desc: "Efficiency lift after turning PMO into VMO." },
        { metric: "12→3", label: "Electromechanical · Documentation (days)", desc: "Cycle reduced with 100% adherence to the new standard." },
        { metric: "93%", label: "Strategy · Plan adherence", desc: "SMO and governance raising strategic execution." },
      ],
    },
    clients: {
      eyebrow: "Environments where we have worked",
      title_a: "Companies we",
      title_em: "learned from and helped evolve.",
      subtitle:
        "Over a decade of accumulated experience between our team's personal trajectory and GT Strategy's projects. Industry, infrastructure, energy, services, agro and crypto.",
    },
    contact: {
      eyebrow: "Let's talk",
      title_a: "Which challenge do",
      title_em: "you want to address?",
      subtitle:
        "Send us an objective message. We reply quickly, directly from our team, with no intermediaries.",
      labels: {
        name: "Name",
        email: "Email",
        company: "Company",
        role: "Role",
        message: "What do you want to talk about?",
      },
      placeholders: {
        name: "Your name",
        email: "you@company.com",
        company: "Company name",
        role: "e.g. COO, Head of Transformation",
        message: "In a few lines, describe the context and the challenge at hand.",
      },
      submit: "Send",
      submitting: "Sending...",
      success: "Got it. We'll be in touch shortly.",
      error: "We couldn't send it now. Please try again or write directly to Guilherme.",
      direct_email: "Or write directly to Guilherme:",
      side_eyebrow: "The starting point",
      side_title: "An initial 30-minute conversation.",
      side_desc:
        "We start by understanding your context. When it makes sense, we move to a diagnostic (1 to 2 weeks) with a clear read on next steps.",
      side_list: [
        "Understanding the context and what's at stake.",
        "Mapping what can be addressed in 30, 60 or 90 days.",
        "Tailored proposal or an honest referral to a partner.",
      ],
    },
    footer: {
      tagline: "We evolve businesses, transform cultures.",
      rights: "All rights reserved.",
      since: "GT Strategy · since 2017",
      sections: { explore: "Navigate", contact: "Talk to us" },
      back_to_top: "Back to top",
      desc: "Consultancy in strategy, operational excellence, digitalization and culture.",
    },
  },
};

const LanguageContext = createContext({ lang: "pt", t: translations.pt, setLang: () => {} });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("pt");
  const value = useMemo(() => ({ lang, t: translations[lang], setLang }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};

export const useLang = () => useContext(LanguageContext);
